import { Link } from "react-router-dom";
import { companyDetails } from "../constant";
import { FaPhone } from "react-icons/fa6";

const CallUsButton = () => {
  return (
    <Link
      to={`tel:${companyDetails.phone}`}
      target="_blank"
      aria-label="Call us now"
      className="hover:-translate-y-1 bg-red-500 transition-all duration-200 text-white flex items-center gap-2 p-3 rounded-full shadow-lg group"
    >
      <FaPhone className="text-[1.5rem] group-hover:scale-110 transition-transform duration-200" />
    </Link>
  );
};

export default CallUsButton;
